<template>
  <footer class="footer px-4 mx-2">
    <b-row align-v="center" class="justify-content-lg-between">
      <b-col lg="6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}}
          <a
            href="https://melior.im"
            class="font-weight-bold ml-1"
            target="_blank"
          >Melior Enterprises Limited</a>
        </div>
      </b-col>
      <b-col lg="6">
        <b-nav class="nav-footer justify-content-center justify-content-lg-end">
          <b-nav-item href="https://www.adminhero.co" target="_blank">Home</b-nav-item>
          <b-nav-item href="mailto:support@adminhero.co" target="_blank">Support</b-nav-item>
        </b-nav>
      </b-col>
    </b-row>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
